import { TabPane } from "reactstrap";
import CommonTabContentTable from "./CommonTabContentTable";

const ThirdTabContent = () => {
  return (
    <TabPane tabId="3">
      <div className="custom-scrollbar">
        <CommonTabContentTable value={2}/>
      </div>
    </TabPane>
  );
};

export default ThirdTabContent;
